// w17 Tilakli — variant. Renders /templates/tilakli.html in a full-bleed
// iframe. Organic forest aesthetic (eucalyptus + olive sage). Same
// pattern as AvgustStaticVariant: forward names/date/venue/address/time
// as URL params, the inline customizer in the HTML walks text nodes and
// swaps mock placeholders before the countdown starts ticking.

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/tilakli.html";

export function TilakliStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();
  if (t.names) params.set("names", t.names);
  if (t.date) params.set("date", t.date);
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  if (t.time) params.set("time", t.time);
  // Forward the public slug so the iframe's RSVP form can POST.
  if (ctx.slug) params.set("slug", ctx.slug);
  // Cache buster — bump when the static HTML changes.
  params.set("v", "4");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;
  return (
    <iframe
      src={src}
      title={t.names || "Tilakli"}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#EDEEDE",
      }}
    />
  );
}
